import React from 'react';
import styled, { css } from 'styled-components';

import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';
import { media } from '@/utils/mixin';

import ScrollBackToTopButton from '../../components/ScrollBackToTopButton';

import Author from './components/Author';
import Date from './components/Date';
import DealerCenters from './components/DealerCenters';
import ExploreAndTry from './components/ExploreAndTry';
import Tags from './components/Tags';
import BottomNavigation from './components/BottomNavigation';
import Others from './components/Others';
import ShareWithYourFriends from './components/ShareWithYourFriends';
import Home from './components/Home';
import Content from './components/Content';
import { dateFormat } from './components/utils';
import Polls from './components/Polls';
import BottomPanel from './components/BottomPanel';

function SinglePost() {
  const page = useTypedSelector(selectSinglePost);

  return (
    <Component>
      <Home />
      <BottomNavigation />
      <ExploreAndTry />
      <Content />
      {page?.id && page?.vote && (
        <Polls
          id={page.id}
          question={page.vote.question}
          answers={page.vote.options}
        />
      )}

      <ComponentContainer>
        {page?.tags && <Tags tags={page.tags} />}

        <AuthorAndDate>
          {page?.authorName && page?.authorText && page?.authorImage && (
            <Author
              authorName={page.authorName}
              authorText={page.authorText}
              avatar={page.authorImage}
            />
          )}
          {page?.datePublished && (
            <Date label={dateFormat(page.datePublished)} />
          )}
        </AuthorAndDate>

        <DealerCenters />
      </ComponentContainer>
      <ShareWithYourFriends />
      <Others />
      <BottomPanel />
      <ScrollBackToTopButton />
    </Component>
  );
}

export default SinglePost;

const Component = styled.div`
  background: ${(props) => props.theme.white};
`;

const ComponentContainer = styled.div`
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  max-width: 67%;

  ${media.tablet(css`
    max-width: 100%;
  `)}
`;

const AuthorAndDate = styled.div`
  margin-top: 20px;
  margin-bottom: 50px;

  @media (min-width: 1400px) {
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin-top: 40px;
    margin-bottom: 70px;
  }
`;
